import { render } from "./EmailLinkCompass.vue?vue&type=template&id=8b86fdb0"
import script from "./EmailLinkCompass.vue?vue&type=script&lang=js"
export * from "./EmailLinkCompass.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__